<template>
  <div class="head-page" :style="isShowHeader ? '':'padding-top:0px;'">
    <Header :title="$t('change.title')" v-show="isShowHeader" />
    <van-row class="exchange-info">
      <van-col :span="16">
        <van-steps direction="vertical" :active="1">
          <van-step>
            <h3>{{ $t("change.from", { name: frmname.label }) }}</h3>
            <p>&nbsp;</p>
          </van-step>
          <van-step>
            <h3>
              {{ $t("change.to", { name: toname.label })
              }}<van-icon name="arrow-down" @click="showPicker = true" />
            </h3>
          </van-step>
        </van-steps>
      </van-col>
      <van-col :span="8" class="txt-center">
        <van-button
          @click="exchange"
          icon="exchange"
          class="web-btn-1"
          style="margin: 0px 0 20px"
        />
        <p
          @click="showPicker1 = true"
          style="font-size: 18px; font-weight: 700"
        >
          {{ money.label }}<van-icon name="arrow-down" />
        </p>
      </van-col>
    </van-row>
    <div class="exchange-box">
      <div class="exchange-frm">
        <p>{{ $t("change.frmtitle") }}</p>
        <van-form @submit="onSubmit">
          <van-field
            v-model="frm.num"
            type="number"
            :placeholder="$t('change.inputplaceholder')"
            :rules="[{ required: true }]"
          >
            <template #extra>
              <span style="margin-right: 10px">{{ money.label }}</span
              >|
              <span style="margin-left: 10px" @click="toall()">{{
                $t("common.all")
              }}</span>
            </template>
          </van-field>
          <p class="account-desc">
            {{ $t("assets.usenum") }} {{ usrinfo.balance }} {{ money.label }}
          </p>
          <div style="margin-top: 16px">
            <van-button native-type="submit" class="web-btn">
              <van-loading v-if="posting" /><span v-else>{{
                $t("change.btntxt")
              }}</span></van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <Footer @hide-header="hideHeader" v-show="!isShowHeader" />
    <van-popup v-model="showPicker" position="bottom" round >
      <van-picker
        show-toolbar
        :columns="accountTypes"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom" round >
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm1"
        @cancel="showPicker1 = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer/index.vue";
export default {
  name: "ChangeMoney",
  components: { Header,Footer },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      isShowHeader:true,
      active: 0,
      frmname: this.$t("assets.tab21"),
      toname: this.$t("assets.tab31"),
      tmp_accountTypes: [
        { value: 2, label: this.$t("assets.tab21") },
        { value: 1, label: this.$t("assets.tab31") },
        { value: 3, label: this.$t("assets.tab41") },
      ],
      accountTypes:[],
      showPicker: false,
      columns: [],
      showPicker1: false,
      money: {},
      usrinfo: {},
      idata:null,
      posting: false,
      frm: {
        c_id: null,
        num: null,
        from_type: null,
        to_type: null,
      }
    };
  },
  mounted() {
    
    this.accountTypes = [];
    this.tmp_accountTypes.forEach((element) => {
      if (element.value == 3) {
        if (this.safeWapConfig.quantize_switch == 1) {
          this.accountTypes.push(element);
        }
      } else {
        this.accountTypes.push(element);
      }
    });
    this.frmname = this.accountTypes[0];
    this.toname = this.accountTypes[1];
    this.getrecharge();
  },
  methods: {
    hideHeader(){
      this.isShowHeader = false
    },
    async onSubmit() {
      if (this.posting) {
        return;
      }
      this.posting = true;
      this.frm.from_type = this.frmname.value
      this.frm.to_type = this.toname.value
      
      await this.$http({
        method: "post",
        url: "transfer",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.frm.num = null;
          this.getrecharge();
        })
        .catch(() => {
          this.posting = false;
        });
    },
    toall() {
      this.frm.num = this.usrinfo.balance;
    },
    onConfirm(val) {
      this.toname = val;
      this.showPicker = false;
      this.usrChange()
    },
    onConfirm1(val) {
      this.money = val;
      this.showPicker1 = false;
      this.frm.num = null;
      this.frm.c_id = val.value;
      this.usrChange()
    },
    exchange() {
      let tmp = this.frmname;
      this.frmname = this.toname;
      this.toname = tmp;
      this.frm.num = null;
      this.usrChange()
    },
    async getrecharge() {
      await this.$http({
        method: "get",
        url: "getUserBalanceList",
      }).then((res) => {
        this.idata = res.data.coinList;
        this.columns = [];
        let tmpitem = {};
        res.data.coinList[0].balanceInfo.forEach((item) => {
          if (this.frm.c_id && this.frm.c_id == item.coinId) {
            tmpitem = { value: item.coinId, label: item.coinName };
          }
          this.columns.push({ value: item.coinId, label: item.coinName });
        });
        if (!this.frm.c_id) {
          tmpitem = this.columns[0];
        }
        this.onConfirm1(tmpitem);
      });
    },
    usrChange(){
      this.idata.forEach(element => {
        if(element.type == this.frmname.value){
          element.balanceInfo.forEach(item => {
            if(item.coinId == this.frm.c_id){
              this.usrinfo  = item
            }
          });
        }
      });
    }
  },
};
</script>

<style>
</style>
